import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PortService } from '../../../../services/forwarding/port.service';
import { Port, CreatePortDto } from '../../../../models/forwarding/port.model';

@Component({
  selector: 'app-ports-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ports-modal.html',
  styleUrl: './ports-modal.css'
})
export class PortsModalComponent implements OnInit, OnDestroy {
  showModal = false;
  showAddModal = false;
  showEditModal = false;
  ports: Port[] = [];
  filteredPorts: Port[] = [];
  searchTerm = '';
  private subscriptions = new Subscription();
  private editingPortId: number | null = null;

  // Form data for add port
  formData: CreatePortDto = {
    code: '',
    name: '',
    country: '',
    region: ''
  };

  // Form data for edit port
  editFormData: CreatePortDto = {
    code: '',
    name: '',
    country: '',
    region: ''
  };

  constructor(private portService: PortService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.portService.getPorts().subscribe(ports => {
        this.ports = ports;
        this.filteredPorts = ports;
        console.log('[PortsModal] Ports updated:', ports.length);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  open(): void {
    this.showModal = true;
  }

  close(): void {
    this.showModal = false;
    this.showAddModal = false;
    this.showEditModal = false;
  }

  filterPorts(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredPorts = this.ports.filter(port =>
      port.code.toLowerCase().includes(term) ||
      port.name.toLowerCase().includes(term) ||
      port.country.toLowerCase().includes(term) ||
      port.region.toLowerCase().includes(term)
    );
  }

  openAddPortModal(): void {
    this.formData = {
      code: '',
      name: '',
      country: '',
      region: ''
    };
    this.showAddModal = true;
  }

  closeAddPortModal(): void {
    this.showAddModal = false;
  }

  createPort(): void {
    if (!this.formData.code || !this.formData.name || !this.formData.country || !this.formData.region) {
      alert('Please fill in all required fields');
      return;
    }

    this.portService.create(this.formData).subscribe({
      next: (port) => {
        console.log('[PortsModal] Port created successfully:', port);
        this.closeAddPortModal();
      },
      error: (error) => {
        console.error('[PortsModal] Error creating port:', error);
        alert('Error creating port. Please try again.');
      }
    });
  }

  editPort(port: Port): void {
    this.editingPortId = port.id;
    this.editFormData = {
      code: port.code,
      name: port.name,
      country: port.country,
      region: port.region
    };
    this.showEditModal = true;
    console.log('[PortsModal] Edit port:', port);
  }

  closeEditPortModal(): void {
    this.showEditModal = false;
    this.editingPortId = null;
  }

  updatePort(): void {
    if (!this.editFormData.code || !this.editFormData.name || !this.editFormData.country || !this.editFormData.region) {
      alert('Please fill in all required fields');
      return;
    }

    if (this.editingPortId === null) {
      alert('Error: No port selected for editing');
      return;
    }

    this.portService.update(this.editingPortId, this.editFormData).subscribe({
      next: (port) => {
        console.log('[PortsModal] Port updated successfully:', port);
        this.closeEditPortModal();
      },
      error: (error) => {
        console.error('[PortsModal] Error updating port:', error);
        alert('Error updating port. Please try again.');
      }
    });
  }

  deletePort(id: number): void {
    if (!confirm('Are you sure you want to delete this port?')) {
      return;
    }

    this.portService.delete(id).subscribe({
      next: () => {
        console.log('[PortsModal] Port deleted successfully');
      },
      error: (error) => {
        console.error('[PortsModal] Error deleting port:', error);
        alert('Error deleting port. Please try again.');
      }
    });
  }
}
